import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";

Vue.config.productionTip = false;
Vue.config.silent = process.env.NODE_ENV === 'production';

// Configurar manejador global de errores para producción
Vue.config.errorHandler = (err, vm, info) => {
  // En producción, no exponer detalles técnicos del error
  if (process.env.NODE_ENV === 'production') {
    // En producción, no mostrar errores en consola
    // Aquí podrías enviar el error a un servicio de logging externo
    // Ejemplo: errorTrackingService.logError(err, vm, info);
    return;
  }
  // En desarrollo, mostrar el error completo
  console.error('Error:', err, info);
};

Vue.config.warnHandler = (msg, vm, trace) => {
  // En producción, suprimir advertencias
  if (process.env.NODE_ENV === 'production') {
    return;
  }
  // En desarrollo, mostrar advertencias
  console.warn('Warning:', msg, trace);
};

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
  created() {
    document.title = "Purdy Mobility System";
  }
}).$mount("#app");
